import packageMetadata from "../package.json";

export const RELEASE_VERSION = packageMetadata.version;
export const RELEASE_CHECKSUMS_PATH = "/downloads/SHA256SUMS";
export const RELEASE_METADATA_PATH = "/downloads/release.json";
